'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
const wipResourceTypes = [ResourceType.ResourceTypeUnspecified, ResourceType.AwsEfs, ResourceType.AwsFsx, ResourceType.AwsKeyspacesTable, ResourceType.AwsNeptune, ResourceType.AzureFileShare, ResourceType.AzureDisk, ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm, ResourceType.AzureSqlDatabase, ResourceType.AzureSqlManagedInstance, ResourceType.AzureMysql, ResourceType.AzureCosmosdbMongodb, ResourceType.AzureCosmosdbNosql, ResourceType.AzureAksNamespace, ResourceType.GcpGkeNamespace, ResourceType.GcpCloudFirestore, ResourceType.GoogleWorkspaceResource, ResourceType.Microsoft365Resource];
export const useSupportedResourceTypes = t0 => {
  const $ = _c(26);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    AzureSqlDatabaseSupport,
    SapHanaPitrSupport,
    AwsKeyspacesSupport,
    AzureFilesSupport,
    GoogleWorkspaceSupport,
    m365BackupConsole
  } = useFeatureFlags();
  let t2;
  if ($[2] !== AwsKeyspacesSupport) {
    t2 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[2] = AwsKeyspacesSupport;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== AzureSqlDatabaseSupport) {
    t3 = AzureSqlDatabaseSupport ? [ResourceType.AzureSqlDatabase] : [];
    $[4] = AzureSqlDatabaseSupport;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== SapHanaPitrSupport) {
    t4 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[6] = SapHanaPitrSupport;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== AzureFilesSupport) {
    t5 = AzureFilesSupport ? [ResourceType.AzureFileShare] : [];
    $[8] = AzureFilesSupport;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== GoogleWorkspaceSupport) {
    t6 = GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [];
    $[10] = GoogleWorkspaceSupport;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== m365BackupConsole) {
    t7 = m365BackupConsole ? [ResourceType.Microsoft365Resource] : [];
    $[12] = m365BackupConsole;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ...t2, ...t3, ...t4, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t5, ...t6, ...t7];
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const ffResources = t8;
  let t9;
  if ($[21] !== cloudProviders || $[22] !== ffResources || $[23] !== isDemo || $[24] !== isDev) {
    t9 = Object.values(ResourceType).filter(x => x !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[x]?.provider) : true) && (isDemo || isDev || !wipResourceTypes.includes(x) || ffResources.includes(x)));
    $[21] = cloudProviders;
    $[22] = ffResources;
    $[23] = isDemo;
    $[24] = isDev;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};